import * as yup from 'yup';
import { BooleanOptions, Roles } from './Data.conf';
import { API as yachts } from '../../yachts/api';

export const FilterConf = {
  schema: yup.object({
    id_yacht: yup.array().nullable(),
  }),
  initialState: {
    value: {
      id_yacht: null,
      crew_responsability: null,
      feedback: null,
      commercial: null,
    },
  },
  fields: [
    {
      id: 'id_yacht',
      name: 'id_yacht',
      type: 'async_autocomplete_multiple',
      label: 'Yacht',
      api: yachts.select,
      required: false,
      xs: 12,
      sm: 4,
    },
    {
      id: 'crew_responsability',
      name: 'crew_responsability',
      type: 'autocomplete',
      label: 'Role',
      options: Roles,
      required: false,
      xs: 12,
      sm: 4,
    },
    {
      id: 'feedback',
      name: 'feedback',
      type: 'autocomplete',
      label: 'Marketing',
      options: BooleanOptions,
      required: false,
      xs: 12,
      sm: 4,
      md: 2,
    },
    {
      id: 'commercial',
      name: 'commercial',
      type: 'autocomplete',
      label: 'Newsletter',
      options: BooleanOptions,
      required: false,
      xs: 12,
      sm: 4,
      md: 2,
    },
  ],
  query: {
    keys: [
      {
        key: 'id_yacht.id',
        value: 'id_yacht.id',
        operator: '$eq',
      },
      {
        key: 'crew_responsability',
        value: 'crew_responsability.label',
        operator: '$eq',
      },
      {
        key: 'id_yacht.feedback',
        value: 'feedback.id',
        operator: '$eq',
      },
      {
        key: 'id_yacht.commercial',
        value: 'commercial.id',
        operator: '$eq',
      },
    ],
  },
};
